import HttpClient from '@/services/http-client'

class MeterTypeClient extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/meter-types/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/meter-types', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/meter-types', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/meter-types/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/meter-types/' + id)
  }
}

export default () => new MeterTypeClient()
